import { render, staticRenderFns } from "./ProductMatrix.vue?vue&type=template&id=6e28a4a4&"
import script from "./ProductMatrix.ts?vue&type=script&lang=ts&"
export * from "./ProductMatrix.ts?vue&type=script&lang=ts&"
import style0 from "./ProductMatrix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QIcon,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh,QIcon,QTd})
